import { ExternalLinkIcon, IconButton, Tooltip } from "@hightouch/htui";
import type { FC } from "react";
import { openUrlInNewTab } from "src/utils/urls";

export const ExternalLink: FC<{ tooltipMessage: string; url: string }> = ({
  tooltipMessage,
  url,
}) => {
  return (
    <Tooltip message={tooltipMessage}>
      <IconButton
        icon={ExternalLinkIcon}
        onClick={() => openUrlInNewTab(url)}
        aria-label={tooltipMessage}
      />
    </Tooltip>
  );
};
